/**
 * Parses a JWT token's payload and returns the object
 *
 * @param token
 */
export function parseJWTToken(token: string) {
  return JSON.parse(atob(token.split('.')[1]));
}
